<template>
  <label class="FieldLabel" :for="forId"><slot /></label>
</template>

<script>
export default {
  name: "FieldLabel",
  props: {
    forId: { type: String, required: true }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.FieldLabel {
  display: block;
  font-size: 16px;
  line-height: 1.4;
  font-weight: $light;
  color: $color-dark;
  padding: 0 0 10px;

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
    padding: 0 0 20px;
  }
}
</style>
